import isObject from 'lodash-es/isObject';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { Generator } from './generator';
import css from '@holmescorp/book-widgets/css/topicgroup.m.css';
const isEleWithKids = (v) => {
    return isObject(v) && 'children' in v;
};
const isSimpleTopic = (v) => {
    return isObject(v) && 'p' in v;
};
const factory = create({ theme }).properties();
export const Shortdesc = factory(({ properties, middleware: { theme } }) => {
    const themeCss = theme.classes(css);
    const { topicdata, additionalClasses = [] } = properties();
    const render_description = (topicdata) => {
        if (isEleWithKids(topicdata)) {
            return w(Generator, {
                skipTitle: true,
                topic: { attributes: {}, children: topicdata.children }
            });
        }
        else if (isSimpleTopic(topicdata)) {
            return w(Generator, {
                skipTitle: true,
                topic: { attributes: {}, children: [topicdata] }
            });
        }
        else if (typeof topicdata === 'string') {
            return topicdata;
        }
        return null;
    };
    return v('div', { classes: [themeCss.deck, ...additionalClasses], xqa: 'shortdesc' }, [
        render_description(topicdata)
    ]);
});
